import { FC } from "react";

import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { IconText } from "mds/components/IconText";
import { HandRaiseIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectCurrentOrg, selectCurrentOrgName } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import {
  ATTENDANCE_THRESHOLD_PROPERTIES,
  DEFAULT_ABSENT_THRESHOLD_MINUTES,
} from "utils/metrics-utils";

export const AttendancePolicyCard: FC = () => {
  const orgName = useAppSelector(selectCurrentOrgName);
  const thresholds = useObjectSelector(selectCurrentOrg, ATTENDANCE_THRESHOLD_PROPERTIES);

  if (!orgName || !thresholds) {
    return null;
  }

  const absentMinutes = thresholds.session_absent_threshold ?? DEFAULT_ABSENT_THRESHOLD_MINUTES;
  const lateMinutes = thresholds.session_late_threshold;
  const description =
    lateMinutes != null
      ? t("session_log_view.attendance_policy.description", { lateMinutes, absentMinutes })
      : t("session_log_view.attendance_policy.description_absent_only", { absentMinutes });

  return (
    <Card className="p-4" kind="blue">
      <IconText
        iconStart={<HandRaiseIcon className="text-blue" />}
        text={
          <h3 className="m-0 text-sm font-medium text-blue">
            {t("session_log_view.attendance_policy.title", { orgName })}
          </h3>
        }
      />

      <p className="body-s mt-4 text-black-tint-20">{description}</p>
    </Card>
  );
};
